export default __webpack_public_path__ + "static/media/Arrow 2.6b1805c2.svg";